<template>
  <section class="bg-white rounded-xl p-6 shadow-card">
    <h2 class="heading-md mb-6 text-gray-900">Latest News</h2>
    <div class="space-y-4">
      <div
        class="flex gap-4 p-4 border border-gray-200 rounded-lg hover:border-primary-300 transition-colors duration-200 hover:shadow-sm group"
        v-for="(article, index) in recentArticles"
        :key="index"
      >
        <div class="flex-shrink-0 w-20 h-20 overflow-hidden rounded-lg bg-gray-100">
          <img
            :src="article.imageBase64"
            :alt="article.title"
            loading="lazy"
            class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
          />
        </div>
        <div class="flex-1 min-w-0">
          <h3 class="text-sm font-semibold text-gray-900 mb-1 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
            {{ article.title }}
          </h3>
          <p class="text-xs text-gray-600 mb-2 line-clamp-2">
            {{ article.description }}
          </p>
          <RouterLink
            :to="`article/${article.slug}`"
            class="inline-flex items-center text-xs font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200"
          >
            Read More
            <svg class="ml-1 w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </RouterLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
  import { computed } from 'vue';
  import { RouterLink } from 'vue-router';

  const props = defineProps({
    articles: {
      type: Array,
      required: true,
    },
  });

  // Compute the 3 most recent articles
  const recentArticles = computed(() => {
    // Assumes articles are already sorted in descending order by recency
    return props.articles.slice(0, 3);
  });
</script>

<style scoped>
  /* Line clamp utilities for text truncation */
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
</style>
